export const BG_LEGEND = require('@/Shared/images/backgrounds/legend_bg_long.png');